import {
  CoverageCatalogItem,
  CoverageOption,
  InsuranceSnapshot,
} from 'types/insurance-catalog';

export const EHR_PROVIDER_NEXTGEN = 'nextgen';

export const INSURANCE_TYPE_TO_CATEGORY: Record<string, string> = {
  PPO: 'Commercial-Pure OON',
  HMO: 'INN/HMO',
  Medicare: 'Medicare',
  'Medicare PPO': 'Medicare PPO',
  'Auto Insurance': 'Motor Vehicle Accident',
  'Workers Comp': 'Workers Comp',
  'Cash Pay': 'Cash Pay',
  EPO: 'EPO',
};

export const insuranceTypeToCategory = (
  typeName?: string,
): string | undefined =>
  typeName ? INSURANCE_TYPE_TO_CATEGORY[typeName] ?? typeName : undefined;

export const catalogItemToOption = (
  item: CoverageCatalogItem,
): CoverageOption => ({
  value: item.id,
  label: item.name,
  item,
});

export const snapshotToOption = (
  snapshot?: InsuranceSnapshot | null,
): CoverageOption | null => {
  if (!snapshot?.coverageId && !snapshot?.name) return null;
  return {
    value: snapshot.coverageId ?? snapshot.name,
    label: snapshot.name,
    item: {
      id: snapshot.coverageId ?? snapshot.name,
      name: snapshot.name,
      insuranceCategory: snapshot.insuranceCategory ?? null,
      ehrProvider: snapshot.ehrProvider ?? EHR_PROVIDER_NEXTGEN,
      ehrExternalId: snapshot.ehrExternalId ?? '',
    },
  };
};

export const optionToSnapshot = (
  option?: CoverageOption | null,
): InsuranceSnapshot | undefined => {
  if (!option?.item) return undefined;
  const { id, name, insuranceCategory, ehrProvider, ehrExternalId } =
    option.item;
  return {
    coverageId: id,
    name,
    insuranceCategory: insuranceCategory ?? null,
    ehrProvider: ehrProvider ?? null,
    ehrExternalId: ehrExternalId ?? null,
  };
};

export const serializeSnapshotOption = (
  option?: CoverageOption | null,
): string => {
  const snapshot = optionToSnapshot(option);
  return snapshot ? JSON.stringify(snapshot) : '';
};

const safeParseSnapshot = (value?: string | null): InsuranceSnapshot | null => {
  if (!value) return null;
  try {
    const parsed = JSON.parse(value);
    if (
      parsed &&
      typeof parsed === 'object' &&
      typeof parsed.name === 'string'
    ) {
      return parsed as InsuranceSnapshot;
    }
    return null;
  } catch {
    return null;
  }
};

export const deserializeSnapshotOption = (
  value?: string | null,
): CoverageOption | null => snapshotToOption(safeParseSnapshot(value));
